<template>
  <div
    class="modal fade"
    id="editLoginAccountModal"
    tabindex="-1"
    data-backdrop="static"
    data-keyboard="false"
    role="dialog"
    aria-labelledby="editLoginAccountModalLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            @click="() => {onResetForm();}"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="editLoginAccountModalLabel"
          >
            {{ $t('string.edit_login_account') }}
          </h4>
        </div>
        <div class="modal-body">
          <div
            class="form-group"
            :class="{'has-error' : validations['phone']}"
          >
            <label
              for="phone"
              class="required"
            >{{ $t('string.phone') }}</label>
            <input
              type="text"
              name="phone"
              class="form-control"
              id="phone"
              v-model="phone"
              :placeholder="$t('string.enter_phone_number')"
            >
            <template v-if="validations['phone']">
              <span class="help-block">{{ validations['phone'][0] }}</span>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button
            @click="() => {onResetForm()}"
            type="button"
            ref="close"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button
            type="button"
            @click="onSave"
            :disabled="isSaveWaiting"
            class="btn btn-primary"
          >
            <i
              class="fa fa-spinner fa-spin"
              v-if="isSaveWaiting"
            /> {{ $t('button.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditLoginAccountModal',
  data () {
    return {
      phone: null,
      validations: {},
      isSaveWaiting: false
    }
  },
  methods: {
    onResetForm () {
      this.validations = {}
      this.phone = null
      this.$refs.close.click()
    },
    onSave () {
      this.isSaveWaiting = true
      this.$axios.post(this.$base_api + '/api/v1/user/update-login-account', {
        borrow_id: this.$route.params.borrow_id,
        phone: this.phone
      }).then(({ data }) => {
        if (data.data) {
          this.onResetForm()
          this.showToastr()
        }
      }).catch((error) => {
        if (error.response.status === 422) {
          this.validations = error.response.data.errors
        } else {
          this.onResponseError(error)
        }
      }).finally(() => {
        this.isSaveWaiting = false
      })
    }
  }
}
</script>

<style scoped>

</style>
